declare global {
  interface Window {
    Telegram?: {
      WebApp: {
        initData: string
        initDataUnsafe: {
          user?: {
            id: number
            first_name: string
            last_name?: string
            username?: string
          }
          chat_instance?: string
          chat_type?: string
          auth_date: number
          hash: string
        }
        colorScheme: 'light' | 'dark'
        themeParams: {
          bg_color?: string
          text_color?: string
          hint_color?: string
          link_color?: string
          button_color?: string
          button_text_color?: string
          secondary_bg_color?: string
        }
        isExpanded: boolean
        viewportHeight: number
        viewportStableHeight: number
        ready: () => void
        expand: () => void
        close: () => void
        sendData: (data: string) => void
        openLink: (url: string) => void
        openTelegramLink?: (url: string) => void
        onEvent?: (event: string, handler: () => void) => void
        offEvent?: (event: string, handler: () => void) => void
      }
    }
  }
}

function applyColorScheme(scheme: 'light' | 'dark') {
  const root = document.documentElement
  root.classList.remove('light', 'dark')
  root.classList.add(scheme)
}

export function initializeTelegram() {
  if (typeof window !== 'undefined' && window.Telegram?.WebApp) {
    const tg = window.Telegram.WebApp
    tg.ready()
    tg.expand()

    applyColorScheme(tg.colorScheme)

    tg.onEvent?.('themeChanged', () => {
      applyColorScheme(tg.colorScheme)
    })

    return {
      user: tg.initDataUnsafe.user,
      colorScheme: tg.colorScheme,
      themeParams: tg.themeParams,
    }
  }

  return null
}

export function getTelegramWebApp() {
  return typeof window !== 'undefined' ? window.Telegram?.WebApp : null
}

/**
 * Returns the raw initData string required for server-side HMAC validation.
 * Returns null when running outside Telegram (e.g. browser dev).
 */
export function getRawInitData(): string | null {
  const tg = getTelegramWebApp()
  return tg?.initData && tg.initData.length > 0 ? tg.initData : null
}

export function sendDataToTelegram(data: Record<string, unknown>) {
  const tg = getTelegramWebApp()
  if (tg) {
    tg.sendData(JSON.stringify(data))
  }
}

/**
 * Open a Telegram link (https://t.me/...) preferably inside the Telegram client.
 * Falls back to openLink (browser) and ultimately to window.open for non-Telegram contexts (dev).
 */
export function openTelegramLink(url: string) {
  const tg = getTelegramWebApp()
  if (tg?.openTelegramLink) {
    tg.openTelegramLink(url)
    return
  }
  if (tg?.openLink) {
    tg.openLink(url)
    return
  }
  if (typeof window !== 'undefined') {
    window.open(url, '_blank', 'noopener,noreferrer')
  }
}
